module.exports = __webpack_public_path__ + "static/media/export-icon.0246481d.svg";